<div class="modal" (click)="clickOuside()">
    <div class="modal-content" (click)="stopPropagation($event)">
        <div class="modal-header"> {{ header }} </div>
        <div class="modal-body">
            <div class="table-recherches" *ngIf="listRecherche">
                <table mat-table [dataSource]="listRecherche.objects" class="mat-elevation-z8">
          
                  <ng-container matColumnDef="titre">
                    <th mat-header-cell *matHeaderCellDef> Titre </th>
                    <td mat-cell *matCellDef="let recherche"> {{recherche.titre}} </td>
                  </ng-container>
          
                  <ng-container matColumnDef="dateCreation">
                    <th mat-header-cell *matHeaderCellDef> Création </th>
                    <td mat-cell *matCellDef="let recherche"> {{recherche.dateCreationDisplay}} </td>
                  </ng-container>
          
                  <ng-container matColumnDef="createur">
                    <th mat-header-cell *matHeaderCellDef> Par </th>
                    <td mat-cell *matCellDef="let recherche"> {{recherche.createur}} </td>
                  </ng-container>
          
                  <ng-container matColumnDef="dateModification">
                    <th mat-header-cell *matHeaderCellDef> Modification </th>
                    <td mat-cell *matCellDef="let recherche"> {{recherche.dateModificationDisplay}} </td>
                  </ng-container>
          
                  <ng-container matColumnDef="modificateur">
                    <th mat-header-cell *matHeaderCellDef> Par </th>
                    <td mat-cell *matCellDef="let recherche"> {{recherche.modificateur}} </td>
                  </ng-container>
          
                  <ng-container matColumnDef="enable">
                    <th mat-header-cell *matHeaderCellDef> Activer/Désactiver </th>
                    <td mat-cell *matCellDef="let recherche">
                        <div class="button">
                          <ng-container *ngIf="recherche.enabled">
                            <div class="icon enable-recherche-icon" (click)="disableRechercheFichePatient(recherche)"
                                title="Désactiver cette recherche lors de l'ouverture d'une fiche patient"></div>
                          </ng-container>
                          <ng-container *ngIf="!recherche.enabled">
                            <div class="icon enable-recherche-icon disabled" (click)="disableRechercheFichePatient(recherche)"
                                title="Activer cette recherche lors de l'ouverture d'une fiche patient"></div>
                          </ng-container>
                        </div>
                    </td>
                  </ng-container>
          
                  <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef> Sélectionner </th>
                    <td mat-cell *matCellDef="let recherche">
                        <div class="button">
                            <div class="icon select-recherche-icon" (click)="loadRecherche(recherche)"
                                title="Sélectionner cette recherche"></div>
                        </div>
                    </td>
                  </ng-container>
          
                  <ng-container matColumnDef="delete">
                    <th mat-header-cell *matHeaderCellDef> Supprimer </th>
                    <td mat-cell *matCellDef="let recherche">
                        <div class="button">
                            <div class="icon delete-recherche-icon" (click)="deleteRecherche(recherche)"
                                title="Supprimer cette recherche"></div>
                        </div>
                    </td>
                  </ng-container>
          
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          
                </table>
            </div>
            <div class="error-message-container" *ngIf="error">
                <div>
                    <div class="error-message">{{error}}</div>
                </div>
            </div>
            <div class="button-wrapper" *ngIf="!isEdit">
                <frg-button (activated)="closeRechercheModal(false)" [backgroundColor]="'var(--darkest-primary)'"
                    [type]="'reset'">Fermer</frg-button>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>